import React from 'react'

const ResultOk = (props) => (
    <svg width="119" height="119" viewBox="0 0 119 119" fill={props.color ? props.color : "#1D79FB"}
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M101.573 17.427C90.3347 6.18916 75.393 0 59.5 0C43.6068 0 28.6648 6.18916 17.427 17.427C6.18893 28.6651 0 43.607 0 59.5C0 75.393 6.18893 90.3347 17.427 101.573C28.6651 112.811 43.6068 119 59.5 119C75.393 119 90.3347 112.811 101.573 101.573C112.811 90.3347 119 75.393 119 59.5C119 43.607 112.811 28.6653 101.573 17.427ZM59.5 112.027C30.5363 112.027 6.97266 88.4637 6.97266 59.5C6.97266 30.5363 30.5363 6.97266 59.5 6.97266C88.4637 6.97266 112.027 30.5363 112.027 59.5C112.027 88.4637 88.4637 112.027 59.5 112.027Z"
            />
        <path
            d="M87.9258 40.4085C86.5645 39.0474 84.357 39.0474 82.9957 40.4087L52.2093 71.1951L36.0033 54.989C34.642 53.6277 32.4344 53.6277 31.0729 54.989C29.7114 56.3503 29.7114 58.5578 31.0729 59.9193L49.744 78.5905C50.4248 79.2713 51.3171 79.6115 52.2091 79.6115C53.1011 79.6115 53.9936 79.271 54.6742 78.5905L87.9258 45.3388C89.2874 43.9775 89.2874 41.77 87.9258 40.4085Z"
            />
    </svg>

)

export default ResultOk
